// extracted by css-extract-rspack-plugin
export default {"button":"_13d96c69","buttonWrapper":"_c00dd7ba","header":"_b9b85680","container":"_a6c4feb8"};